// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app\\\\components\\\\shared\\\\EventsGrid\\\\components\\\\EventCard.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app\\components\\shared\\EventsGrid\\components\\EventCard.tsx");
  import.meta.hot.lastModified = "1757171103351.3674";
}
// REMIX HMR END

export function EventCard({
  image,
  date,
  time,
  title,
  href
}) {
  return <a href={href} className="group block transition-all duration-300">
      <div className="flex flex-col">
        {/* Event Image */}
        <div className="aspect-[4/3] overflow-hidden rounded-lg bg-neutral-100 mb-4">
          <img src={image} alt={title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" />
        </div>

        <div className="flex items-center h-[80px] ">
          {/* Date Section */}
          <div className="flex flex-col items-center justify-center px-6 py-4 border border-black/10 bg-gray-50/50">
            <div className="text-heading-5 leading-none !text-black">
              {date.day}
            </div>
            <div className="text-body-3 uppercase !text-black/60 mt-1">
              {date.month}
            </div>
          </div>

          {/* Event Details */}
          <div className="flex-1 px-6 py-4">
            <h3 className="text-heading-5 !text-black uppercase tracking-wider">
              {title}
            </h3>
            <p className="text-body-3 !text-black/50 mt-1">{time}</p>
          </div>
        </div>
      </div>
    </a>;
}
_c = EventCard;
var _c;
$RefreshReg$(_c, "EventCard");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;